import { ObjectView } from '../object';

export class Tile extends ObjectView{
	bgcolor:string;
	textcolor:string;
	title:string;
    description:string;
    fonttype:number;
}